/*
  System Info module State.
*/

/* ---------------------------------------------------------- */

import * as entityUtils from '@/core/utils/entityUtils';

/* ---------------------------------------------------------- */

/** Feature Flag Names - corresponding to values on database. */
const FeatureFlagNames = {};
entityUtils.assignReadOnlyProps(FeatureFlagNames, {
  version4: 'Version4',
  fieldCalc_RowFormula: 'fieldCalc_RowFormula',
  fieldCalc_Aggregation: 'FieldCalc_Aggregation',
  fieldCalc_MdmAggregation: 'FieldCalc_MdmAggregation',
  fieldCalc_AIChat: 'FieldCalc_AIChat',
});
Object.freeze(FeatureFlagNames);

/* ---------------------------------------------------------- */

const STATE = {
  auditLog: {
    data: [],
    loading: false,
    pagination: {
      perPage: 50,
      currentPage: 1,
    },
    filter: {},
  },
  systemSettings: {
    testEmailModal: {
      isOpen: false,
      fields: [
        { id: 'to', label: 'To', value: '', type: 'email' },
        { id: 'subject', label: 'Subject', value: 'Test email from Atlas Portal', type: 'text' },
        { id: 'message', label: 'Message', value: 'Test email from Atlas Portal', type: 'textarea' },
      ],
    },
    data: [],
    requestData: null,
    loading: false,
    /** Feature Flag Names - corresponding to values on database. */
    featureFlagNames: FeatureFlagNames,
    /** Feature Flags - Stored on database & visible/editable via System Settings. */
    featureFlags: null,
    featureFlagsLoadingState: false,
  },
};

export default STATE;

/* ---------------------------------------------------------- */
